import React from 'react';
import classnames from 'classnames';
import styles from './PersonButton.styl';
import Checkmark from '-!svg-react-loader!../../assets/Check_Mark_Reps.svg';
/* eslint import/no-webpack-loader-syntax: off */

class PersonButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false
    }
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick = () => {
    this.props.setSelectedMembers(this.props.index);
  };

  render() {
    return (
      <div>
        {this.props.contactType === 'call'
          ? <a
              href={`tel:${this.props.member.phone.replace(/\D+/g, '')}`}
              style={{ textDecoration: 'none' }}
            >
              <div
                className={classnames(
                  styles.button,
                  this.props.selected ? [styles.shadow] : ''
                )}
                style={{
                borderColor: this.props.selected ? '' : this.props.color
              }}
                onClick={this.handleClick}
              >
                <div
                  style={{ backgroundColor: this.props.color }}
                  className={styles.box}
                >
                  <Checkmark
                    height={20}
                    width={20}
                    style={{ opacity: this.props.selected ? '1' : '0.25' }}
                  />
                </div>
                <div
                  className={styles.name}
                  style={{ color: this.props.color }}
                >
                  <p>
                    {this.props.member.name}
                  </p>
                  <p>
                    {this.props.member.phone}
                  </p>
                </div>
              </div>
            </a>
          : <div
              className={classnames(
                styles.button,
                this.props.selected ? [styles.shadow] : ''
              )}
              style={{
                borderColor: this.props.selected ? '' : this.props.color
              }}
              onClick={this.handleClick}
            >
              <div
                style={{ backgroundColor: this.props.color }}
                className={styles.box}
              >
                <Checkmark
                  height={20}
                  width={20}
                  style={{ opacity: this.props.selected ? '1' : '0.25' }}
                />
              </div>
              <h3 style={{ color: this.props.color }} className={styles.name}>
                {this.props.member.name}
              </h3>
            </div>}
      </div>
    );
  }
}

export default PersonButton;



// WEBPACK FOOTER //
// ./src/components/person/PersonButton.js